export default "__VITE_ASSET__DouvoiHL__"